import React, {Fragment} from "react";
import Card from "../../components/card/Card";
import NsDataTable from "../../components/tabelle/NsDataTable";
import NsButtonActionsGroup from "../../components/buttons/NsButtonActionsGroup";
import NsButtonAction from "../../components/buttons/NsButtonAction";

export default function ConfImpostazioniView({
                                                 data,
                                                 translate,
                                                 onRowDbClickImpostazione,
                                             }) {

    return (
        <Card
            icon={'fas fa-sliders'}
            title={'Impostazioni'}
        >
            <NsDataTable
                data={data}
                columns={[
                    {
                        name: translate('Area'),
                        selector: row => row.area,
                        sortable: true,
                        filtroHeader: {
                            filterFunction: (item, filtro) => (item.area && item.area.toLowerCase().includes(filtro.toLowerCase()))
                        }
                    },
                    {
                        name: translate('Codice'),
                        selector: row => row.codice,
                        sortable: true,
                        filtroHeader: {
                            filterFunction: (item, filtro) => (item.codice && item.codice.toLowerCase().includes(filtro.toLowerCase()))
                        }
                    },
                    {
                        name: translate('Descrizione'),
                        selector: row => row.descrizione,
                        sortable: true,
                        filtroHeader: {
                            filterFunction: (item, filtro) => (item.descrizione && item.descrizione.toLowerCase().includes(filtro.toLowerCase()))
                        }
                    },
                    {
                        name: translate('Valore'),
                        selector: row => {
                            var valore = ''
                            if (row.tipo === 'L') {
                                var valori = row.valori_previsti.split(';')
                                var valFiltrato = valori.filter((val) => val.split('=')[0] === row.valore)
                                if (valFiltrato) {
                                    valore = valFiltrato[0].split('=')[1]
                                }
                            } else if (row.tipo === 'B') {
                                valore = row.valore === '1' ? 'Sì' : 'No';
                            } else if (row.tipo === 'MS') {
                                let valori_registrati = row.valore;
                                let valore_registrato = valori_registrati.split(',');

                                let valori_previsti = row.valori_previsti.split(';');

                                var valore_app = ''
                                for (let v = 0; v < valore_registrato.length; v++) {
                                    let singolo_valore_registrato = valore_registrato[v];

                                    for (let i = 0; i < valori_previsti.length; i++) {
                                        var valSingolo = valori_previsti[i].split('=')
                                        var valSingolo_cod = valSingolo[0];
                                        var valSingolo_descr = valSingolo[1];

                                        if (singolo_valore_registrato == valSingolo_cod) {
                                            if (valore_app != '') {
                                                valore_app = valore_app + ', '
                                            }
                                            valore_app = valore_app + valSingolo_descr;
                                        }
                                    }
                                }
                                valore = valore_app;
                            } else {
                                valore = row.valore.length > 50 ? row.valore.substr(0, 50) + '...' : row.valore
                            }
                            return valore
                        },
                        sortable: false,
                    },
                    {
                        name: '',
                        selector: row => <Fragment>
                            <NsButtonActionsGroup>
                                <li>
                                    <NsButtonAction
                                        label={"Modifica"}
                                        icona={"fas fa-pen"}
                                        href={"/upd-parametro/" + row.id}
                                    />
                                </li>
                            </NsButtonActionsGroup>
                        </Fragment>,
                        sortable: false,
                        right: true,
                    }
                ]}
                onRowDbClick={onRowDbClickImpostazione}
            />
        </Card>
    );
}
